import Vue from "vue";
import $ from "jquery";
import Toasted from 'vue-toasted';
import VueDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import DibbleApi from './api';
import DibbleTranslation from "./translation/translation";
import DibbleConfigs from "./dibble-config";
import UserMenuRoleModuleAssignment from "./utils/UserMenuRoleAssignments";
import Authorizations from "./utils/authorizations";

Vue.use(require('vue-moment'));
Vue.use(require('vue-cookies'));
Vue.use(Toasted);
Vue.use(VueDialog);

const DibbleJS = {
    config: {
        tinyCloudApi: DibbleConfigs.tinyCloudApi
    },
    state: {
        apiStack: []
    },
    roleAssignment: UserMenuRoleModuleAssignment,
    AnchorNoHandlerHref: 'javascript:void(0)',
    initDefaultDropdownChoice(element, default_value = '') {
        const value = {
            text: DibbleTranslation.trans('global.label.select_default'),
            value: default_value
        };

        element.push(value);
        return element;
    },
    cookieDestroy() {
        Vue.$cookies.remove('_user');
        Vue.$cookies.remove('_token');
    },
    isAllowedAccess(module_name) {
        const userAuth = Vue.$cookies.get('_user');
        return Authorizations.isAllowedAccess(parseInt(userAuth.permission_level), module_name);
    },
    getDefaultDropDownChoice(default_value = '') {
        return {
            text: DibbleTranslation.trans('global.label.select_default'),
            value: default_value
        };
    },
    toggleActions(id, module_str) {
        DibbleJS.collapseAllOtherActions(id, module_str);
        const btn = $('#' + module_str + '-action-' + id);
        if ($(btn).is(":visible")) {
            $(btn).removeClass('d-flex').hide();
            $(btn).next('.collapse').show();
        } else {
            $(btn).addClass('d-flex').show();
            $(btn).next('.collapse').hide();
        }
    },
    collapseAllOtherActions(exceptId = '', module_str) {
        $('.' + module_str + '-action-btn').each(function () {
            if (exceptId !== '' && exceptId === $(this).data(module_str + '-id')) {
                DibbleJS.logEventConsole("Ignored " + exceptId);
            } else {
                $(this).addClass('d-flex');
                $(this).next('.collapse').hide();
            }
        })
    },
    showLoader() {
        $('.global-loading').show();
    },
    hideLoader() {
        $('.global-loading').hide();
    },
    confirmBox(message, callBack) {
        let options = {
            html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
            loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
            reverse: false, // switch the button positions (left to right, and vise versa)
            okText: DibbleTranslation.trans('global.label.btn.confirm'),
            cancelText: DibbleTranslation.trans('global.label.btn.cancel'),
            animation: 'zoom', // Available: "zoom", "bounce", "fade"
            type: 'basic', // coming soon: 'soft', 'hard'
            verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
            backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
            customClass: '' // Custom class to be injected into the parent node for the current dialog instance
        };

        Vue.dialog
            .confirm(message, options)
            .then(function () {
                callBack();
            })
    },
    toastErrorMessage(message) {
        const options = {
            type: 'error',
            theme: 'bubble',
            duration: 5000,
            position: 'bottom-center'
        };
        Vue.toasted.show(message, options);
    },
    toastSuccessMessage(message) {
        const options = {
            type: 'success',
            theme: 'bubble',
            duration: 5000,
            position: 'bottom-center'
        };
        Vue.toasted.show(message, options);
    },
    checkIsExpiredSession() {
        if (!Vue.$cookies.get('_token')) {
            return window.location.href = '/login';
        }
    },
    getStorageToken() {
        return Vue.$cookies.get('_token')
    },
    callApiRequest(data, successCallback, preventOverlapCall = false) {
        if (window.location.href.indexOf('registration') < 0 && window.location.href.indexOf('login') < 0 && window.location.href.indexOf('calendar') < 0
            && window.location.href.indexOf('widgets/view') < 0 && window.location.href.indexOf('widgets/payment') < 0
        ) {
            const token = Vue.$cookies.get('_token');
            if (!token) {
                return window.location.href = '/login';
            }
            data['#token'] = token;
        }

        if (preventOverlapCall) {
            const isProcessing = DibbleJS.state.apiStack.find(apiName => apiName === data.request);
            if (typeof isProcessing !== 'undefined') {
                DibbleJS.logEventConsole('Duplicate called event name ', data.request);
                return false;
            }
        }
        DibbleJS.state.apiStack.push(data.request);
        $.ajax({
            url: DibbleApi.endpoint[process.env.NODE_ENV],
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            success: function (responseData) {
                DibbleJS._removeApiStack(data.request);
                if (parseInt(responseData.rc) === 201) {
                    window.location.href = '/login';
                } else {
                    DibbleJS.apiSuccessCallBack(data, responseData, successCallback)
                }
            },
            error: function (xhr, textStatus, errorThrown) {
                DibbleJS._removeApiStack(data.request);
                console.log('error');
                console.log(errorThrown);
                DibbleJS.hideLoader();
                DibbleJS.toastErrorMessage(DibbleTranslation.trans('global.error.api.error'))
            }
        });
    },
    callGetRequest(url, successCallback) {
        $.ajax({
            url: url,
            type: 'GET',
            data: '',
            success: successCallback,
            error: function (xhr, textStatus, errorThrown) {
                DibbleJS.logEventConsole('error');
                DibbleJS.logEventConsole(errorThrown);
            }
        });
    },
    apiSuccessCallBack(data, responseData, successCallback) {
        console.log('request => ', data);
        console.log('response => ', responseData);
        successCallback(responseData);
    },
    isResponseObjectHasData(objects) {
        return typeof objects.length === 'undefined';
    },
    logEventConsole(thing) {
        if (process.env.NODE_ENV === 'development') {
            console.log(thing);
        }
    },
    _removeApiStack(apiName) {
        if (DibbleJS.state.apiStack.length === 1) {
            DibbleJS.state.apiStack = [];
        } else {
            DibbleJS.state.apiStack = DibbleJS.state.apiStack.filter(item => item !== apiName);
        }

        console.log('apiStack => ', DibbleJS.state.apiStack);
    }
}

export default DibbleJS;
